// Angular
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
// RxJS
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../../auth';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { selectTwixorToken } from '../../../auth/_selectors/auth.selectors';
import { AppState } from '../../../reducers';

/**
 * More information there => https://medium.com/@MetonymyQT/angular-http-interceptors-what-are-they-and-how-to-use-them-52e060321088
 */
@Injectable()
export class InterceptService implements HttpInterceptor {
  private twixorToken: string;
  constructor(
    private authenticationService: AuthService,
    private router: Router,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(selectTwixorToken)).subscribe((res) => (this.twixorToken = res));
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Add Twixor Token for APIs.
    if (
      request.url.indexOf('/twixor/sync-users') > -1 ||
      request.url.indexOf('/twixor/change-status') > -1 ||
      request.url.indexOf('/twixor/logout') > -1
    ) {
      const headers = request.headers.set('twixor-token', this.twixorToken);
      request = request.clone({
        headers,
      });
    }
    return next.handle(request).pipe(
      catchError((err) => {
        if ([401].includes(err.status) && request.url.indexOf('/api/v2/auth/session') === -1) {
          // auto logout if 401 or 403 response returned from api
          this.authenticationService.logout();
        }
        if ([403].includes(err.status)) {
          this.router.navigateByUrl('/error/403');
        }
        if (!(err?.url?.indexOf('/sso_check') > -1) && [404].includes(err.status)) {
          this.router.navigateByUrl('/error/404');
        }
        return throwError(err);
      }),
    );
  }
}
